(() => {
  const decode = value => String(value ?? '').replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ').replace(/&#39;|&apos;/g, "'").replace(/&quot;/g, '"');
  const optionText = (p, pattern) => (p.options || []).filter(o => pattern.test(o.name)).flatMap(o => o.values.map(v => typeof v === 'object' ? v.name : v)).join('; ');
  const tagText = (p, pattern) => (p.tags || []).filter(t => pattern.test(t)).map(t => t.replace(/^[^_]+_/, '')).join('; ');
  const matchesText = (text, pattern) => pattern.test(decode(text));
  const classify = (p, mode, specs = {}) => {
    const spec = specs[p.id] || {};
    const details = spec.type === p.type ? (spec.details || {}) : {};
    const type = decode(p.type || '');
    const leaf = type.split(' > ').at(-1);
    const scenes = decode([details['Applicable Scene'], details['Suitable Rooms'], tagText(p, /^Applications_/i)].filter(Boolean).join('; ')).replace(/dinning/ig, 'Dining');
    let primary;
    if (mode === 'indoor') {
      if (p.id === '7600821764320' && /linear wall sconces/i.test(type)) primary = 'ceiling';
      else if (/chandelier/i.test(type)) primary = 'chandelier';
      else if (/pendant|linear suspension/i.test(type)) primary = 'pendant';
      else if (/ceiling lights/i.test(type)) primary = 'ceiling';
      else if (/wall light/i.test(type)) primary = 'wall';
      else if (/table lamp|floor lamp/i.test(type)) primary = 'lamps';
      else primary = 'more_indoor';
    } else {
      if (/outdoor wall|wall wash/i.test(type)) primary = 'wall';
      else if (/bollard|path lights|step.*deck/i.test(type)) primary = 'path';
      else if (/pillar|lamp posts|post lights|street lighting/i.test(type)) primary = 'pillar';
      else if (/spotlight|novelty|well light|underwater|flood|landscape lighting|tree lighting|string light/i.test(type)) primary = 'landscape';
      else primary = 'more_outdoor';
    }
    const office = mode === 'indoor' && /office|study/i.test(scenes) && !/LED Wall Art|Staircase Chandelier/i.test(type);
    const dining = mode === 'indoor' && ['pendant', 'chandelier'].includes(primary) && /dining|kitchen island|long tables|restaurant/i.test(decode(scenes + ' ' + p.title + ' ' + (spec.description || '')));
    const types = [primary, ...(office ? ['office'] : []), ...(dining ? ['dining'] : [])];
    const roomRules = mode === 'indoor' ? [
      ['living', /living room/i], ['dining_room', /dining room|restaurant/i], ['kitchen', /kitchen/i], ['bedroom', /bedroom|bedside/i], ['home_office', /office|study/i], ['hallway', /hallway|corridor/i], ['entryway', /entry|entrance|foyer|mudroom/i], ['bathroom', /bathroom/i]
    ] : [['garden_patio', /garden|patio|lawn|courtyard|yard/i], ['front_entry', /entrance|porch|balcony|corridor/i], ['driveway_gate', /driveway|gate/i], ['path_walkway', /path|walkway/i]];
    const rooms = roomRules.filter(([, re]) => re.test(scenes)).map(([key]) => key);
    const powerText = decode([details['Power Supply'], details['Power Source'], optionText(p, /power supply|power source/i), tagText(p, /^PowerSource_/i)].join('; '));
    const power = [];
    if (/solar/i.test(powerText)) power.push('solar');
    if (/hardwire|hard wire|hardwired|mains/i.test(powerText)) power.push('hardwired');
    if (/plug/i.test(powerText)) power.push('plug_in');
    if (/battery|usb|recharge/i.test(powerText)) power.push('rechargeable');
    const solar = mode === 'outdoor' && power.includes('solar');
    const mixedSolar = solar && /hardwire|battery|usb|plug/i.test(powerText);
    const sensorText = decode([details['Control Type'], optionText(p, /style|sensor|control/i)].join('; '));
    const motion = /motion sensor/i.test(sensorText) || /motion.*sensor/i.test(p.title);
    const motionOptional = motion && /no motion sensor|without sensor|no sensor/i.test(sensorText);
    const brightness = decode(details['Brightness Dimming']);
    const dimOptions = optionText(p, /color temperature|dimm/i);
    const dimText = decode([brightness, details['Color Temperature'], dimOptions].join('; '));
    const dimmable = /(^|[,;\s])yes\b/i.test(brightness) || /(^|[;,\s])dimmable\b/i.test(dimText);
    const dimOptional = dimmable && !/^yes/i.test(brightness);
    const features = [];
    if (dimmable) features.push('dimmable');
    if (motion) features.push('motion_sensor');
    if (/integrated/i.test(decode([details['Light Source'], details['Bulb Type'], tagText(p, /^LightSource_/i)].join('; ')))) features.push('integrated_led');
    if (/replaceable|e27|e26|gu10|g9|e14/i.test(decode([details['Bulb Base'], details['Bulb Type'], details['Light Source'], tagText(p, /^BulbBase_/i)].join('; ')))) features.push('replaceable_bulb');
    if (/remote/i.test(decode([details['Control Type'], optionText(p, /control/i)].join('; ')))) features.push('remote_control');
    if (/adjustable|rotatable|rotating|foldable/i.test(decode(p.title + ' ' + details['Adjustable']))) features.push('adjustable');
    if (/smart|wifi|wi-fi|zigbee|bluetooth/i.test(decode([details['Control Type'], optionText(p, /control/i)].join('; ')))) features.push('smart_compatible');
    let installText = decode(details['Mounting Type']);
    if (p.id === '7600821764320' && primary === 'ceiling') installText = 'Ceiling Mount';
    const mountingConflict = mode === 'outdoor' && leaf === 'Outdoor Flush Mount Lights' && /wall mount/i.test(installText);
    if (mountingConflict) installText = '';
    const installation = [];
    if (!mountingConflict && /semi.?flush/i.test(type)) installation.push('semi_flush');
    else if (!mountingConflict && /flush mount/i.test(type)) installation.push('flush_mount');
    if (/recessed|trimless/i.test(type)) installation.push('recessed');
    if (/track/i.test(type)) installation.push('track');
    if (/ceiling/i.test(installText) && !['semi_flush', 'flush_mount', 'recessed', 'track'].some(v => installation.includes(v))) installation.push('ceiling_mount');
    if (['pendant', 'chandelier'].includes(primary) && !/flush|recessed/i.test(type)) installation.push('suspended');
    if (/wall/i.test(installText)) installation.push('wall_mounted');
    if (/pillar|pier|post/i.test(installText)) installation.push('pier_post_mount');
    if (/ground|stake/i.test(installText)) installation.push('ground_mount');
    if (/plug/i.test(powerText)) installation.push('plug_in');
    const styleText = decode([details['Style'], details['Product Style'], tagText(p, /^(Style|ProductStyle)_/i)].join('; '));
    const styleRules = [['modern', /modern/i], ['contemporary', /contemporary/i], ['mid_century', /mid.?century/i], ['farmhouse', /farmhouse/i], ['traditional', /traditional/i], ['minimalist', /minimalis/i], ['industrial', /industrial/i], ['american_classic', /american classic/i], ['luxury', /luxury/i]];
    const styles = styleRules.filter(([, re]) => re.test(styleText)).map(([key]) => key);
    const finishText = decode([details['Color'], details['Finish'], optionText(p, /^(color|colour|finish)$/i), tagText(p, /^(Color|Finish)_/i)].join('; '));
    const finishRules = [['black', /\bblack\b/i], ['white', /\bwhite\b/i], ['gold', /\bgold\b/i], ['brass', /\bbrass\b/i], ['bronze', /\bbronze\b/i], ['silver', /\bsilver\b/i], ['gray', /\bgr[ae]y\b/i], ['brown', /\bbrown\b/i], ['copper', /\bcopper\b/i], ['wood', /\bwood|walnut|oak\b/i]];
    const finishes = finishRules.filter(([, re]) => re.test(finishText)).map(([key]) => key);
    const materialText = decode([details['Material'], details['Fixture Material'], tagText(p, /^(Material|FixtureMaterial)_/i)].join('; '));
    const materials = [['metal', /metal|aluminum|aluminium|iron|steel|copper|brass/i], ['glass', /glass/i], ['stone', /stone|alabaster|marble/i], ['wood', /wood|walnut|oak/i], ['crystal', /crystal/i], ['acrylic', /acrylic/i]].filter(([, re]) => re.test(materialText)).map(([key]) => key);
    const weatherText = decode([details['Ingress Protection'], details['IP Rating'], tagText(p, /^(IngressProtection|IPRating)_/i)].join('; '));
    const weather = [...new Set((weatherText.match(/IP\s*\d{2}/ig) || []).map(s => s.replace(/\s/g, '').toUpperCase()))];
    const budget = [];
    if (p.price < 10000) budget.push('under100');
    if (p.price < 30000) budget.push('under300');
    if (p.price >= 10000 && p.price < 20000) budget.push('price100200');
    if (p.price >= 20000 && p.price < 50000) budget.push('price200500');
    if (p.price >= 50000) budget.push('price500plus');
    const offerBudget = [];
    if (p.sale && Number.isFinite(p.offerPrice) && p.offerPrice > 0) {
      if (p.offerPrice < 10000) offerBudget.push('under100');
      else if (p.offerPrice < 20000) offerBudget.push('price100200');
      else if (p.offerPrice < 50000) offerBudget.push('price200500');
      else offerBudget.push('price500plus');
    }
    const subtypes = mode === 'outdoor' ? [
      ['step_deck', /step.*deck/i], ['bollard', /bollard/i], ['path_lights', /path lights/i], ['pillar_lights', /pillar/i], ['post_lights', /lamp posts?\b|post lights\b/i], ['street_lights', /street lighting/i], ['spotlights', /spotlight/i], ['well_lights', /well light/i], ['underwater_lights', /underwater/i], ['flood_lights', /flood/i], ['string_lights', /string light/i], ['lanterns', /lantern/i], ['floor_lights', /floor lamp/i], ['hanging_lights', /hanging/i], ['outdoor_ceiling', /outdoor flush mount/i], ['accent_lights', /novelty|tree lighting/i]
    ].filter(([, re]) => re.test(leaf)).map(([key]) => key) : [];
    return { ...p, primary, leaf, office, dining, solar, mixedSolar, motion, motionOptional, dimmable, dimOptional,
      facets: { type: types, room: rooms, installation, style: styles, finish: finishes, material: materials, power, weather, feature: features, price: budget, offer_price: offerBudget, subtype: subtypes, offer: p.sale ? ['on_sale'] : [] } };
  };
  const pickFacet = pick => ['solar', 'hardwired'].includes(pick) ? 'power' : /^IP\d{2}$/.test(pick) ? 'weather' : ['dimmable', 'replaceable_bulb', 'remote_control', 'adjustable', 'motion_sensor'].includes(pick) ? 'feature' : pick === 'under300' ? 'price' : 'type';
  const areaMatch = (p, area) => {
    if (!area) return true;
    if (area === 'gate') return p.primary === 'pillar' || p.facets.room.includes('driveway_gate');
    if (area === 'walkway') return p.primary === 'path' || p.facets.room.includes('path_walkway');
    if (area === 'entry') return p.primary === 'wall';
    if (area === 'garden') return p.primary === 'landscape' || (p.primary === 'more_outdoor' && p.facets.room.includes('garden_patio'));
    return true;
  };
  const matches = (p, state, exclude = '') => areaMatch(p, state.area) && Object.entries(state.facets).every(([facet, values]) => facet === exclude || !values.length || values.some(v => p.facets[facet]?.includes(v)));
  const select = (products, state) => {
    const list = products.filter(p => matches(p, state));
    if (state.sort === 'price-asc') list.sort((a, b) => a.price - b.price || a.position - b.position);
    else if (state.sort === 'price-desc') list.sort((a, b) => b.price - a.price || a.position - b.position);
    else if (state.sort === 'title') list.sort((a, b) => a.title.localeCompare(b.title) || a.position - b.position);
    return list;
  };
  const slicePage = (products, page, size = 20) => products.slice((page - 1) * size, page * size);
  globalThis.DazumaBsModel = Object.freeze({ classify, matches, select, slicePage, areaMatch, pickFacet });
  if (typeof document === 'undefined' || customElements.get('dz-best-seller-collection')) return;
  const el = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  };
  class BestSellerCollection extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abortController = new AbortController();
      this.mode = this.dataset.mode;
      this.labels = Object.fromEntries(Object.entries(JSON.parse(this.querySelector('[data-bs-labels]').textContent)).map(([key, value]) => [key, decode(value)]));
      this.state = { facets: {}, area: '', sort: 'collection', page: 1 };
      this.grid = this.querySelector('[data-bs-grid]');
      this.panel = this.querySelector('[data-bs-filters]');
      this.cards = new Map();
      const raw = JSON.parse(this.querySelector('[data-bs-products]').textContent);
      this.collectCards(this);
      const signal = this.abortController.signal;
      this.addEventListener('click', event => this.onClick(event), { signal });
      this.addEventListener('change', event => this.onChange(event), { signal });
      this.addEventListener('keydown', event => this.onKeydown(event), { signal });
      window.addEventListener('resize', () => { if (window.innerWidth >= 990) this.closeFilters(); }, { signal });
      const specPromise = fetch(this.dataset.specsUrl, { signal }).then(r => r.ok ? r.json() : {}).catch(() => ({}));
      try {
        let next = raw.next;
        while (next) {
          const url = new URL(next, location.origin);
          const current = new URL(location.href);
          for (const name of ['view', 'preview_theme_id']) if (current.searchParams.has(name)) url.searchParams.set(name, current.searchParams.get(name));
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal });
          if (!response.ok) throw new Error('catalog');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const data = JSON.parse(page.querySelector('[data-bs-products]').textContent);
          if (!data.items.length) throw new Error('catalog');
          const previousLength = raw.items.length;
          const ids = new Set(raw.items.map(p => p.id));
          raw.items.push(...data.items.filter(p => !ids.has(p.id)));
          if (raw.items.length === previousLength) throw new Error('catalog');
          this.collectCards(page);
          next = data.next;
        }
        const specs = await specPromise;
        if (!this.isConnected) return;
        this.products = raw.items.map((p, index) => classify({ ...p, position: index }, this.mode, specs));
        this.initUrl();
        this.querySelectorAll('[data-bs-pick], [data-bs-open], [data-bs-clear], [data-bs-sort]').forEach(button => button.disabled = false);
        this.updateDeals();
        this.render();
      } catch (error) {
        if (error.name !== 'AbortError') this.querySelector('[data-bs-status]').textContent = this.labels.load_error;
      }
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.closeFilters();
      this.removeModals();
      this.initialized = false;
    }
    collectCards(root) {
      root.querySelectorAll('template[data-bs-card]').forEach(card => this.cards.set(card.dataset.bsCard, card));
    }
    label(key) { return this.labels[key] || key; }
    text(key, values) {
      return Object.entries(values).reduce((value, [name, replacement]) => value.replaceAll('[' + name + ']', replacement), this.label(key));
    }
    initUrl() {
      const url = new URL(location.href);
      const typeAliases = { chandelier: 'chandelier', pendant: 'pendant', wall: 'wall', ceiling: 'ceiling', pillar: 'pillar', bollard: 'path', path: 'path', floor: 'more_outdoor' };
      const spaceAliases = { entrance: this.mode === 'outdoor' ? 'front_entry' : 'entryway', garden: 'garden_patio', dining: 'dining_room', living: 'living', kitchen: 'kitchen', office: 'home_office' };
      if (typeAliases[url.searchParams.get('bs_type')]) this.state.facets.type = [typeAliases[url.searchParams.get('bs_type')]];
      if (spaceAliases[url.searchParams.get('bs_space')]) this.state.facets.room = [spaceAliases[url.searchParams.get('bs_space')]];
      const encoded = url.searchParams.get('bs_filters');
      if (encoded) {
        try {
          const saved = JSON.parse(encoded);
          const facets = {};
          for (const [facet, values] of Object.entries(saved.facets || {})) {
            if (this.facetDefinitions().some(([key]) => key === facet) && Array.isArray(values)) facets[facet] = values.filter(value => this.products.some(p => p.facets[facet]?.includes(value)));
          }
          this.state.facets = facets;
          this.state.area = ['gate', 'walkway', 'entry', 'garden'].includes(saved.area) ? saved.area : '';
          this.state.page = Math.max(1, Number(saved.page) || 1);
        } catch (_) {}
      }
    }
    syncUrl() {
      const url = new URL(location.href);
      url.searchParams.delete('bs_type');
      url.searchParams.delete('bs_space');
      if (this.filterCount() || this.state.page !== 1) url.searchParams.set('bs_filters', JSON.stringify({ facets: this.state.facets, area: this.state.area, page: this.state.page }));
      else url.searchParams.delete('bs_filters');
      history.replaceState(null, '', url);
    }
    facetDefinitions() {
      const indoor = [['material', 'material'], ['type', 'product_type'], ['room', 'room'], ['installation', 'installation'], ['feature', 'light_feature'], ['price', 'price'], ['offer', 'offers'], ['offer_price', 'offer_price'], ['style', 'style'], ['finish', 'finish']];
      const outdoor = [['material', 'material'], ['type', 'product_type'], ['room', 'installation_area'], ['power', 'power_source'], ['installation', 'installation'], ['weather', 'weather_rating'], ['feature', 'light_feature'], ['price', 'price'], ['offer', 'offers'], ['offer_price', 'offer_price'], ['subtype', 'fixture_detail'], ['finish', 'finish']];
      return this.mode === 'indoor' ? indoor : outdoor;
    }
    facetValues(facet) {
      const available = new Set(this.products.flatMap(p => p.facets[facet] || []));
      const preferred = { type: ['ceiling', 'office', 'dining', 'pendant', 'chandelier', 'wall', 'lamps', 'path', 'pillar', 'landscape', 'more_indoor', 'more_outdoor'], room: ['living', 'dining_room', 'kitchen', 'bedroom', 'home_office', 'hallway', 'entryway', 'bathroom', 'front_entry', 'driveway_gate', 'path_walkway', 'garden_patio'], price: ['under100', 'under300', 'price100200', 'price200500', 'price500plus'] };
      return [...new Set([...(preferred[facet] || []), ...available])].filter(v => available.has(v));
    }
    buildFacets() {
      const target = this.querySelector('[data-bs-facets]');
      const open = new Set([...target.querySelectorAll('details[open]')].map(d => d.dataset.facet));
      const first = !target.children.length;
      const fragment = document.createDocumentFragment();
      this.facetDefinitions().forEach(([facet, label], index) => {
        const values = this.facetValues(facet);
        if (!values.length) return;
        const detail = el('details', 'dz-split__facet');
        detail.dataset.facet = facet;
        detail.open = open.has(facet) || (first && index < 2) || (this.state.facets[facet]?.length > 0);
        detail.append(el('summary', '', this.label(label)));
        const options = el('div', 'dz-split__facet-options');
        values.forEach(value => {
          const count = this.products.filter(p => matches(p, this.state, facet) && p.facets[facet].includes(value)).length;
          const row = el('label', 'dz-split__facet-option');
          const input = el('input');
          input.type = 'checkbox';
          input.dataset.bsFacet = facet;
          input.value = value;
          input.checked = !!this.state.facets[facet]?.includes(value);
          input.disabled = count === 0 && !input.checked;
          row.append(input, el('span', '', this.label(value)), el('small', '', String(count)));
          options.append(row);
        });
        detail.append(options);
        fragment.append(detail);
      });
      const focused = document.activeElement;
      const focusData = focused?.dataset.bsFacet ? { facet: focused.dataset.bsFacet, value: focused.value } : null;
      target.replaceChildren(fragment);
      if (focusData) [...target.querySelectorAll('input')].find(i => i.dataset.bsFacet === focusData.facet && i.value === focusData.value)?.focus({ preventScroll: true });
    }
    filterCount() {
      return Object.values(this.state.facets).reduce((total, values) => total + values.length, this.state.area ? 1 : 0);
    }
    removeModals() {
      document.querySelectorAll('quick-view-modal[data-dz-bs-owner]').forEach(modal => {
        if (modal.dataset.dzBsOwner === this.dataset.sectionId) modal.remove();
      });
    }
    render(scroll = false) {
      const selected = select(this.products, this.state);
      const pageCount = Math.max(1, Math.ceil(selected.length / 20));
      this.state.page = Math.min(this.state.page, pageCount);
      const visible = slicePage(selected, this.state.page);
      this.removeModals();
      const fragment = document.createDocumentFragment();
      visible.forEach(p => {
        const template = this.cards.get(p.id);
        if (!template) return;
        const card = template.content.cloneNode(true);
        const context = card.querySelector('[data-bs-context]');
        const type = card.querySelector('[data-bs-type]');
        if (p.id === '7600821764320') type.textContent = this.label('ceiling');
        if (p.solar) context.textContent = this.label(p.mixedSolar ? 'solar_option' : 'solar_powered');
        else if (p.motion) context.textContent = this.label(p.motionOptional ? 'motion_option' : 'motion_sensor');
        else if (this.mode === 'outdoor' && p.facets.weather.length) context.textContent = p.facets.weather.join(' · ');
        else if (p.facets.room.length) context.textContent = this.label('suited_to') + ' ' + p.facets.room.slice(0, 2).map(r => this.label(r)).join(' & ');
        else if (p.dimmable) context.textContent = this.label(p.dimOptional ? 'dimmable_option' : 'dimmable');
        card.querySelectorAll('quick-view-modal').forEach(modal => modal.dataset.dzBsOwner = this.dataset.sectionId);
        fragment.append(card);
      });
      this.grid.replaceChildren(fragment);
      this.querySelector('[data-bs-empty]').hidden = selected.length !== 0;
      const start = selected.length ? (this.state.page - 1) * 20 + 1 : 0;
      this.querySelector('[data-bs-status]').textContent = this.text('results', { start, end: Math.min(this.state.page * 20, selected.length), count: selected.length });
      this.querySelector('[data-bs-drawer-count]').textContent = '(' + selected.length + ')';
      this.querySelector('[data-bs-filter-count]').textContent = this.filterCount() ? '(' + this.filterCount() + ')' : '';
      this.querySelectorAll('[data-bs-clear]').forEach(button => button.disabled = this.filterCount() === 0);
      this.buildFacets();
      this.buildActive();
      this.buildPagination(pageCount, selected.length);
      this.querySelectorAll('[data-bs-pick]').forEach(button => {
        const pick = button.dataset.bsPick;
        const facet = pickFacet(pick);
        button.setAttribute('aria-pressed', pick === 'all' ? String(this.filterCount() === 0) : String(!!this.state.facets[facet]?.includes(pick)));
        const state = { ...this.state, facets: { ...this.state.facets } };
        if (pick === 'all') { state.facets = {}; state.area = ''; }
        else state.facets[facet] = [pick];
        const count = this.products.filter(p => matches(p, state)).length;
        button.querySelector('[data-bs-pick-count]').textContent = String(count);
        button.disabled = count === 0 && button.getAttribute('aria-pressed') !== 'true';
      });
      this.syncUrl();
      if (scroll) this.scrollToCatalog();
    }
    buildActive() {
      const target = this.querySelector('[data-bs-active]');
      const fragment = document.createDocumentFragment();
      for (const [facet, values] of Object.entries(this.state.facets)) for (const value of values) {
        const button = el('button', '', this.label(value));
        button.type = 'button';
        button.dataset.bsRemove = facet;
        button.dataset.value = value;
        button.append(el('span', '', '×'));
        button.setAttribute('aria-label', this.text('remove_filter', { filter: this.label(value) }));
        fragment.append(button);
      }
      if (this.state.area) {
        const button = el('button', '', this.label('area_' + this.state.area) + ' ×');
        button.type = 'button';
        button.dataset.bsRemove = 'area';
        fragment.append(button);
      }
      target.replaceChildren(fragment);
    }
    buildPagination(count, productsCount) {
      const target = this.querySelector('[data-bs-pagination]');
      const fragment = document.createDocumentFragment();
      if (productsCount > 20) {
        const add = (page, label, disabled, current = false) => {
          const button = el('button', '', label);
          button.type = 'button';
          button.dataset.bsPage = String(page);
          button.disabled = disabled;
          if (current) button.setAttribute('aria-current', 'page');
          if (/^\d+$/.test(label)) button.setAttribute('aria-label', this.text('go_page', { page }));
          fragment.append(button);
        };
        add(this.state.page - 1, this.label('previous'), this.state.page === 1);
        let last = 0;
        for (let i = 1; i <= count; i++) {
          if (i === 1 || i === count || Math.abs(i - this.state.page) <= 1 || count <= 5) {
            if (last && i - last > 1) fragment.append(el('span', '', '…'));
            add(i, String(i), false, i === this.state.page);
            last = i;
          }
        }
        add(this.state.page + 1, this.label('next'), this.state.page === count);
        fragment.append(el('span', '', this.text('page_of', { page: this.state.page, pages: count })));
      }
      target.replaceChildren(fragment);
    }
    updateDeals() {
      const offers = this.products.filter(p => p.sale);
      const section = this.querySelector('[data-bs-deals]');
      section.hidden = !offers.length;
      if (!offers.length) {
        const heroLink = this.querySelector('.dz-split__actions a[href^="#DzBsDeals"]');
        if (heroLink) { heroLink.href = '#DazumaCatalog'; heroLink.textContent = this.label('shop_by_category'); }
        return;
      }
      this.querySelector('[data-bs-offer-count]').textContent = '(' + offers.length + ')';
      const picks = ['under100', 'price100200', 'price200500', 'price500plus'];
      const target = this.querySelector('[data-bs-deal-picks]');
      target.replaceChildren();
      picks.forEach(pick => {
        const count = offers.filter(p => p.facets.offer_price.includes(pick)).length;
        if (!count) return;
        const link = el('a', '', this.label(pick) + ' (' + count + ') →');
        link.href = '#DazumaCatalog';
        link.dataset.bsOfferPick = pick;
        target.append(link);
      });
    }
    onClick(event) {
      const target = event.target.closest('button, a');
      if (!target || !this.contains(target) || target.disabled || !this.products) return;
      if (target.matches('[data-bs-open]')) { this.openFilters(target); return; }
      if (target.matches('[data-bs-close], [data-bs-backdrop]')) { this.closeFilters(); return; }
      let changed = false;
      let scroll = false;
      if (target.matches('[data-bs-clear]')) { this.state.facets = {}; this.state.area = ''; changed = true; }
      if (target.matches('[data-bs-pick], [data-bs-preset]')) {
        event.preventDefault();
        const pick = target.dataset.bsPick || target.dataset.bsPreset;
        if (target.dataset.bsPreset) { this.state.facets = {}; this.state.area = ''; scroll = true; }
        if (pick === 'all') { this.state.facets = {}; this.state.area = ''; }
        else {
          const facet = pickFacet(pick);
          const current = this.state.facets[facet] || [];
          this.state.facets[facet] = current.length === 1 && current[0] === pick && !target.dataset.bsPreset ? [] : [pick];
        }
        changed = true;
      }
      if (target.matches('[data-bs-area]')) { event.preventDefault(); this.state.facets = {}; this.state.area = target.dataset.bsArea; changed = true; scroll = true; }
      if (target.matches('[data-bs-offers], [data-bs-offer-pick]')) {
        event.preventDefault(); this.state.facets = { offer: ['on_sale'] }; this.state.area = '';
        if (target.dataset.bsOfferPick) this.state.facets.offer_price = [target.dataset.bsOfferPick];
        changed = true; scroll = true;
      }
      if (target.matches('[data-bs-remove]')) {
        const facet = target.dataset.bsRemove;
        if (facet === 'area') this.state.area = '';
        else this.state.facets[facet] = this.state.facets[facet].filter(v => v !== target.dataset.value);
        changed = true;
      }
      if (target.matches('[data-bs-page]')) { this.state.page = Number(target.dataset.bsPage); this.render(true); return; }
      if (changed) { this.state.page = 1; this.render(scroll); }
    }
    onChange(event) {
      if (!this.products) return;
      if (event.target.matches('[data-bs-sort]')) { this.state.sort = event.target.value; this.state.page = 1; this.render(); }
      if (event.target.matches('[data-bs-facet]')) {
        const facet = event.target.dataset.bsFacet;
        const selected = new Set(this.state.facets[facet] || []);
        if (event.target.checked) selected.add(event.target.value); else selected.delete(event.target.value);
        this.state.facets[facet] = [...selected];
        this.state.page = 1;
        this.render();
      }
    }
    onKeydown(event) {
      if (!this.panel?.classList.contains('is-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); this.closeFilters(); }
      if (event.key === 'Tab') {
        const focusable = [...this.panel.querySelectorAll('button:not(:disabled), input:not(:disabled), summary, a[href]')].filter(node => node.getClientRects().length);
        const first = focusable[0];
        const last = focusable.at(-1);
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    }
    openFilters(button) {
      this.returnFocus = button;
      this.panel.classList.add('is-open');
      this.panel.setAttribute('role', 'dialog');
      this.panel.setAttribute('aria-modal', 'true');
      this.panel.setAttribute('aria-label', this.label('filter_best_sellers'));
      button.setAttribute('aria-expanded', 'true');
      this.querySelector('[data-bs-backdrop]').hidden = false;
      document.documentElement.classList.add('dz-bs-filter-open');
      this.panel.querySelector('[data-bs-close]').focus();
    }
    closeFilters() {
      if (!this.panel?.classList.contains('is-open')) return;
      this.panel.classList.remove('is-open');
      this.panel.removeAttribute('role');
      this.panel.removeAttribute('aria-modal');
      this.panel.removeAttribute('aria-label');
      this.querySelector('[data-bs-open]').setAttribute('aria-expanded', 'false');
      this.querySelector('[data-bs-backdrop]').hidden = true;
      document.documentElement.classList.remove('dz-bs-filter-open');
      this.returnFocus?.focus({ preventScroll: true });
    }
    scrollToCatalog() {
      const header = document.querySelector('#shopify-section-header, .section-header, header-group');
      const offset = Math.min(220, (header?.getBoundingClientRect().height || 120) + 24);
      const top = this.querySelector('[data-bs-catalog]').getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }
  customElements.define('dz-best-seller-collection', BestSellerCollection);
})();

